module.exports = __webpack_public_path__ + "static/media/poly.6ce00812.svg";